


import React from "react";
import styles from "./productPageBanner.module.css";
import AutoBreadcrumbs from "./breadCrumbs/AutoBreadcrumbs";


interface ProductPageBannerProps {
    title?: string; // category name (ex: "LPS Corals")
}


const capitalizeFirst = (str?: string): string => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
};

const ProductPageBanner: React.FC<ProductPageBannerProps> = ({ title }) => {
    return (
        <section className={`${styles.bannerSection} d-flex align-items-center justify-content-center`}>
            <div className="container text-center">
                <AutoBreadcrumbs/>
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-10 col-12">
                        <div className={styles.bannerContent}>
                            <h1 className={styles.bannerTitle}>{capitalizeFirst(title)}</h1>

                            <div className="mt-3">
                                <a href="tel:438-899-6925"  className="btn btn-outline-light btn-lg">
                                    Contact Us To Order
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductPageBanner;

